<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' class="m-b-25" :initialValues="search" :onFinish='pageSearchChange'
        layout='inline'>
        <a-form-item>
          <a-button @click="()=>{$router.go(-1)}"><LeftOutlined />返回</a-button>
        </a-form-item>
        <a-form-item>
          <a-radio-group v-model:value="search.day_type" button-style="solid" @change="onChangeDay">
            <a-radio-button :value="1">最近7天</a-radio-button>
            <a-radio-button :value="2">最近30天</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="" name=''>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <echartCake :echartsData='echartData' v-if='!listLoading'></echartCake>
      <p class="text-ac m-b-25">{{$route.query.type == 2 ? '门店' :  '商品'}}Top30排名GMV：{{gmv}}</p>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columns'
        :data-source='data'>
        <template #customTitle>
          <span>{{$route.query.type==2?"门店名称":"商品名称"}}</span>
        </template>
        <template v-slot:no="{ index }">
          <p>{{index+1}}</p>
        </template>
      </a-table>
      
    </a-card>
  </a-layout>
</template>
<script>
  import { LeftOutlined } from '@ant-design/icons-vue';
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getOrderStatisticsStoreRead,getOrderStatisticsProductRead,getOrderStatisticsDealerRead } from "@/api/order";
  import { iscode } from "@/utils/app";
  let defSearch = {
    day_type: 1,
    start_time: '',
    end_time: '',
  };
  export default {
    components: { LeftOutlined},
    setup(props, { emit }) {
      // 列表数据和列头配置
      let data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        gmv:0,
        echartData: {},
        time: [],
        listLoading: false,
        columns: [
          {
            title: '排行',
            dataIndex: "no",
            key: "no",
            slots: { customRender: 'no' },
          },
          {
            dataIndex: "name",
            key: "name",
            slots: { title: 'customTitle' },
          },
          {
            title: "下单人数",
            dataIndex: "order_count",
            key: "order_count",
          },
          {
            title: "支付订单数",
            dataIndex: "order_pay_count",
            key: "order_pay_count",
          },
          {
            title: "总金额",
            dataIndex: "order_price_count",
            key: "order_price_count",
          },
        ]
      });
      const $route = inject('$route')
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const onChangeDay = () => {
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
        initData(search.value);
      }
      const onChange = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
        search.value.day_type = 0
      }
      // 页面筛选项搜索
      const pageSearchChange = () => {
        initData(search.value);
      };
      const initData = async (values) => {
          state.listLoading = true;
        try {
          let res  
          if($route.query.type==2){
            res = await getOrderStatisticsProductRead({...values,product_id:$route.query.id}).then(res => res.data);
          }else if($route.query.type==1){
            res = await getOrderStatisticsStoreRead({...values,store_id:$route.query.id}).then(res => res.data);
          }else{
            res = await getOrderStatisticsDealerRead({...values,dealer_id:$route.query.id}).then(res => res.data);
          }
          if (iscode(res)) {
            state.echartData = res.data
            data.value = res.data.list;
            state.gmv = data.value[0].order_price_count
          } else {
            message.error(res.msg);
          }
          state.listLoading = false;
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        onChangeDay,
        onChange,
        pageSearchChange
      };
    },
  };
</script>
<style lang="less" >
  .ant-table td {
    white-space: nowrap;
  }
</style>